import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ChangeLogItemStatusConstants } from '@shared/constants/status.constants';
import { ChangeLogItemStatus } from '@shared/services/gql.service';
import { Utils } from '@shared/utils/utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    <div
      class="flex items-center whitespace-nowrap"
      [ngClass]="{
        'justify-center': params.data.change_log_item_status === this.noStatus,
      }"
    >
      <div class="mr-1 h-3 w-3 rounded-full" [ngClass]="bgClass"></div>
      <div [ngClass]="textClass">{{ status }}</div>
    </div>
  `,
})
export class ChangeLogItemStatusComponent implements ICellRendererAngularComp {
  bgClass!: string;
  noStatus = ChangeLogItemStatus.STATUS_NO_STATUS;
  params!: ICellRendererParams;
  status!: string;
  STATUS_CONFIG = ChangeLogItemStatusConstants.config;
  textClass!: string;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const status: ChangeLogItemStatus | string = params.data.change_log_item_status || '';

    const types = this.STATUS_CONFIG.find((config) => {
      return status === config.value;
    });

    this.bgClass = types?.circleClass || '';
    this.textClass = types?.textClass || '';
    this.status = types?.text || Utils.zeroHyphen;
  }

  refresh(): boolean {
    return false;
  }
}
